module.exports = __webpack_public_path__ + "img/sakuya izayoi scarlet_sc2.16ce2de9.png";